import {Injectable} from '@angular/core';
// import {Store} from '@ngrx/store';
// import {selectOrderCompletion, selectUser} from '@store/reducers';
// import {OrderCompletionState} from '@store/reducers/order-completion.reducer';
// import {AccountService} from '@services/account.service';
// import {takeUntil} from 'rxjs/operators';
// import {Subject} from 'rxjs/Subject';
// import {ModalDataSet} from '@store/actions/modal.action';
// import {UserService} from '@services/user.service';
// import {User} from '@models/user.interface';
// import {Subscription} from 'rxjs/Subscription';
import {Api} from '../utils';
import {HttpParams} from '@angular/common/http';
import {SnackBarComponent} from '@components/snackbar/snackbar.component';
import {PrintFormatEnum, PrintSettingsEnum, PrintTypeEnum} from '@models/print.enum';
import {MatSnackBar} from '@angular/material';

@Injectable()
export class PrintDocumentsService {
  // orderCompletion: OrderCompletionState;
  // private unsubscribe: Subject<void> = new Subject();
  // public subscription: Subscription = new Subscription();

  constructor(
    // private store: Store<any>,
    // private accountService: AccountService,
    // private userService: UserService,
    public matSnackBar: MatSnackBar,
    private api: Api
  ) {
    /*
    this.store.select(selectOrderCompletion)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
      this.orderCompletion = data;
    });
    */
  }

  printFreightDocsByConsignmentNumber(
    consignmentNumbers: string|string[],
    type: PrintTypeEnum = PrintTypeEnum.LABEL,
    format: PrintFormatEnum = PrintFormatEnum.PDF,
    printer: PrintSettingsEnum = PrintSettingsEnum.REGULAR
  ) {
    if (Array.isArray(consignmentNumbers)) {
      consignmentNumbers = consignmentNumbers.join();
    }

    if (consignmentNumbers === '') {
      return this.snackBar('Du måste välja minst en sändning.');
    }

    // this.snackBar('Documenten genereras och öppnas i ett nytt fönster.', false);

    const params = new HttpParams()
      .set('consignment_number', String(consignmentNumbers))
      .set('type', String(type))
      .set('format', String(format))
      .set('printer', String(printer));

    const url = this.api.getUrl('documents/print') + '?' + params.toString();

    return window.open(url, '_blank');
  }

  printFreightDocsByOrderId(
    id: number,
    type: PrintTypeEnum = PrintTypeEnum.LABEL,
    format: PrintFormatEnum = PrintFormatEnum.PDF,
    printer: PrintSettingsEnum = PrintSettingsEnum.REGULAR
  ) {
    const params = new HttpParams()
      .set('type', String(type))
      .set('format', String(format))
      .set('printer', String(printer));

    const url = this.api.getUrl('documents/orders/' + id + '/print') + '?' + params.toString();

    return window.open(url, '_blank');
  }

  printOrderReceipt(id: number) {
    const url = this.api.getUrl('documents/orders/' + id + '/receipt');

    return window.open(url, '_blank');
  }

  private snackBar(text: string, isError: boolean = true): void {
    this.matSnackBar.openFromComponent(SnackBarComponent, {
      data: {
        error: isError,
        message: text
      },
      panelClass: 'snackbar-container',
      duration: 3000,
    });
  }

  /*

  static generateFrame(data, id, format?: string) {
    const blob = new Blob([data], {type: format && format === 'ZPL' ? 'text/plain' : 'application/pdf'});
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    iframe.id = id;
    document.body.appendChild(iframe);
    return iframe;
  }

  printFrame(iframe) {
    iframe.contentWindow.focus();
    setTimeout(() => iframe.contentWindow.print(), 10);
  }

  printDocument(link, id) {
    this.subscription.add(this.store.select(selectUser)
      .subscribe((user: User) => {
        this.accountService.getLabelBlob(link)
          .subscribe((blob) => {
            let iframe = document.getElementById(id);
            if (!iframe) {
              iframe = PrintDocumentsService.generateFrame(blob, id, user.settings.unifaun_printer_format);
            }
            this.printFrame(iframe);
            return;
          });
      }));
  }

  printOrderLabels() {
    this.accountService.getShipmentDocuments()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (this.orderCompletion.documents.labels.length) {
          this.orderCompletion.documents.labels.forEach(label => this.printDocument(label.link, label.id));
        } else {
          this.store.dispatch(new ModalDataSet({
            bodyModalText: 'Labels have not been generated yet. Please try again later!',
            removeShow: false,
            showCancel: false,
            showOk: true
          }));
        }
      })
  }

  printOrderReceipts() {
    this.accountService.getShipmentDocuments()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (this.orderCompletion.documents.receipts.length) {
          this.orderCompletion.documents.receipts.forEach(
            receipt => this.printDocument(receipt.link, receipt.id)
          );
        } else {
          this.store.dispatch(new ModalDataSet({
            bodyModalText: 'Receipts have not been generated yet. Please try again later!',
            removeShow: false,
            showCancel: false,
            showOk: true
          }));
        }
      })
  }

  unsubscribeUser() {
    this.subscription.unsubscribe();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  */
}



// WEBPACK FOOTER //
// ./src/app/services/print-documents.service.ts